import { getRelativeTime } from '@/utils/common'

export class Comment {
  id = null
  version_id = null
  message = null
  createdAt = null
  versionScopedId = null
  userId = null
  userName = null
  userAvatar = null
  readMore = false
  fullMessage = ''
  mentionedUsers = []
  siteOwnerId = null
  siteId = null
  viewed = false
  commentedBy = 'user'

  constructor(origin) {
    if (!origin) return

    this.id = origin.id
    this.commentedBy = origin.commented_by
    this.userId = origin.user_id
    this.userName = this.commentedBy == 'user' ? origin.user_name : 'Forge AI'
    this.mentionedUsers = origin.mentioned_users
    this.userAvatar = this.commentedBy == 'user' ? origin.user_avatar : require('@/assets/svg/LogoSmall.svg')
    this.version_id = origin.version_id
    this.createdAt = getRelativeTime(new Date(origin.created_at)).toLowerCase()
    this.message = origin.message
    this.siteOwnerId = origin.site_owner_id
    this.versionScopedId = origin.version_scoped_id
    this.siteId = origin.site_id
    this.viewed = origin.viewed
  }

  getServerObject() {
    return {
      version_id: this.version_id,
      message: this.message,
    }
  }
}
